import { render, staticRenderFns } from "./supportingFacilities.vue?vue&type=template&id=afc903b2&scoped=true"
import script from "./supportingFacilities.vue?vue&type=script&lang=js"
export * from "./supportingFacilities.vue?vue&type=script&lang=js"
import style0 from "./supportingFacilities.vue?vue&type=style&index=0&id=afc903b2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afc903b2",
  null
  
)

export default component.exports